import { cn } from "cn";

/**
 * Центрирующий контейнер с ограничением ширины.
 * Единая ширина контента для всех секций сайта.
 */
export function Container({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={cn("mx-auto w-full max-w-6xl px-4 sm:px-6", className)}>
      {children}
    </div>
  );
}
